var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.width,"height":_vm.height,"viewBox":_vm.viewBox}},[_c('g',{attrs:{"fill":_vm.color}},[_c('rect',{attrs:{"width":"32","height":"4","x":"0","y":"0","fill":"rgb(0,0,0)","rx":"0","ry":"0"}}),_c('rect',{attrs:{"width":"18","height":"4","x":"14","y":"7","fill":"rgb(0,0,0)","rx":"0","ry":"0"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }